var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',{staticClass:"app-container"},[_c('el-header',{staticClass:"app-header"},[_c('Header')],1),_c('el-main',{staticClass:"app-main"},[_c('router-view')],1),_c('el-footer',{staticClass:"app-footer"},[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }